import React, { useState } from 'react';
import { Button } from './ui/button';
import { Phone, Mail, Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-32">
          {/* Logo - Bigger */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_roof-clean-heroes/artifacts/dpmknklk_Screenshot%202025-10-24%20202236.png" 
              alt="Vancouver House Wash" 
              className="h-28 w-auto cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          {/* Desktop Navigation - Pages displayed across */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              Testimonials
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <Button
              onClick={() => scrollToSection('booking')}
              size="lg"
              className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 hover:bg-green-800 hover:shadow-xl transition-all !font-medium !text-sm gap-2 px-6 py-6 rounded-md shadow-lg text-white !bg-[#135E31]">Request a Quote


            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-green-700 transition-colors">

            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen &&
      <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left py-3 text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              About Us
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-3 text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left py-3 text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left py-3 text-gray-700 hover:text-green-700 font-semibold text-lg transition-colors">
              Testimonials
            </button>
            <Button
            onClick={() => scrollToSection('booking')}
            className="w-full bg-green-700 hover:bg-green-800 text-white py-6 text-lg font-semibold transition-all">

              Request a Quote
            </Button>
          </div>
        </div>
      }
    </header>);

};

export default Header;